export default {
	getWorks: state=> state.works.works,
	getCrumb: state=> state.crumb.crumb,
	getUser: state=> state.user.user,
	getSubject: state=> state.subject.subject,
	getCatalog: state=> state.catalog.catalog,
  showToast: state=>state.toast.toast,
	getNavSate: state => state.navstate.navstate,
}



// WEBPACK FOOTER //
// ./src/store/getters.js